module.exports = __webpack_public_path__ + "static/media/appointment-list-icon.00b79548.svg";